import {HttpClient} from '@angular/common/http';
import {Injectable, Injector, OnInit} from '@angular/core';
import {Observable} from "rxjs";
import {Versao} from "../../../domain/Versao";
import {AuthService} from "@auth0/auth0-angular";
import {environment} from "../../../../environments/environment";

@Injectable()
export abstract class AbstractHttpService<T>{
    abstract url: string

    public auth: AuthService
    public http: HttpClient
    constructor(injector: Injector) {
      this.http = injector.get(HttpClient)
      this.auth = injector.get(AuthService)
    }

    get urlBase(){
      return environment.url+this.url
    }

  bulk(items: T[]) : Observable<T[]>{
    return this.http.post<T[]>(this.urlBase +'/bulk', items)
  }


  sync(limite: number, v: Versao|null): Observable<T[]>{
        const req =`${(this.urlBase)}/sync?limite=${limite}` + (v == null ? '' :  `&ultimaDataHora=${v.versao}&id=${v.id}`)
        // console.log(this.auth.getAccessTokenSilently())
        return this.http.get<T[]>( req )
    }

    getVersao(): Observable<Versao[]>{
      console.log(`Baixando versão: ${this.urlBase}/sync`)
      return this.http.get<Versao[]>(this.urlBase + '/sync')
    }
}
